export default __webpack_public_path__ + "static/media/avatar-s-15.37a99cd4.jpg";